import { Box, Divider, Grid, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import React from 'react';
import { useSelector } from 'react-redux';
import strings from '../../Globalization/index';
import connectionService from '../../services/Connection';
import { customTopSectionInputComponentMapper } from '../endosystemcycleinfoviews/TopSection';
import { useSterilizerCycleInfo } from './Context';

const TopSection = () => {
	const theme = useTheme();
	const { DateFormat, TimeFormat } = useSelector((state => state?.auth?.tags));
	const DateTimeFormat = `${DateFormat} ${TimeFormat === '12 hour' ? 'hh:mm A' : 'HH:MM'}`;
	const { data, onAddBIResult } = useSterilizerCycleInfo();
	const items = data.TopSection || [];
	const evalItemValue = (item) => {
		let value = item.value;
		switch (item.type) {
			case 'date':
			case 'datetime':
				value = item?.value ? dayjs(item.value) : null;
				if (value?.isValid?.()) {
					value = value.format(item.type === 'datetime' ? DateTimeFormat : DateFormat);
				} else {
					value = null;
				}
				break;

			default:
				break;
		}
		return value;
	}

	return (
		<Grid container>
			<Grid size={{ xs: 12, lg: 3 }} sx={{ mt: theme.spacing(), padding: theme.spacing() }}>
				<Stack alignItems={'center'}>
					<Box className="cycle">
						<Box
							component="img"
							src={`${connectionService.PTXImage}/${data.SterilizerImageUrl}?v=${new Date()}`}
							alt={data.EquipmentName}
							sx={{ height: theme.spacing(8), width: 'auto' }}
							height={theme.spacing(8)}
							width={'auto'}
						/>
					</Box>
					{!!data?.EquipmentName && (
						<Typography
							className="cycle-serialNumber"
							variant="h5"
							fontWeight={'bold'}
							title={strings.EquipmentName}
							component="span"
						>
							{data.EquipmentName}
						</Typography>
					)}
					{!!data?.ModelName && (
						<Typography
							className="cycle-serialNumber"
							variant="subtitle2"
							fontWeight={'bold'}
							title={strings.ModelName}
							component="span"
						>
							{data.ModelName}
						</Typography>
					)}
					{!!data?.SerialNumber && (
						<Typography
							className="cycle-serialNumber"
							variant="subtitle2"
							fontWeight={'bold'}
							title={strings.SerialNumber}
							component="span"
						>
							{data.SerialNumber === '-1' ? '' : data.SerialNumber}
						</Typography>
					)}
				</Stack>
			</Grid>
			<Grid size={{ xs: 12, lg: 9 }} sx={{ mt: theme.spacing(), padding: theme.spacing() }}>
				<Box
					sx={{
						fontSize: 13,
						display: 'grid',

						gridTemplateColumns: '1fr 1em 1fr 1fr 1em 1fr',
						gap: '3px 5px',
						'& .LabelBold': {
							fontWeight: 'bold'
						}
					}}
				>
					{items.map(({ HeaderLabel: name, Value: value, DataProperty, type }, index) => {
						const CustomInputComponent = customTopSectionInputComponentMapper[DataProperty];
						const openFormProp = DataProperty === 'BIResultIcon' ? 'BIResult' : 'CIResult'
						const finalValue = CustomInputComponent
							? <CustomInputComponent
								CriticalParameterIcon={value}
								align='left'
								ml={0}
								data={data}
								dataProperty={DataProperty}
								Value={value}
								handleFormOpen={() => onAddBIResult(openFormProp)}
							/>
							: (
								<Typography fontSize="inherit" key={`value-${index}`}>
									{value || evalItemValue({
										value: value || data[name],
										type
									})}
								</Typography>
							);

						return (
							<React.Fragment key={index}>
								<Typography className="LabelBold" fontSize="inherit">
									{strings[name] || name}
								</Typography>
								<Typography variant="body2" fontSize="inherit" className="LabelBold">
									:
								</Typography>
								{finalValue}
							</React.Fragment>
						);
					})}

				</Box>
			</Grid>
			<Grid size={12}>
				<Divider />
			</Grid>
		</Grid>
	);
};
export default TopSection;
